var render = function render(){var _vm=this,_c=_vm._self._c;return _c('on-viewport',{attrs:{"rootMargin":_vm.rootMargin,"thresholds":_vm.thresholds},on:{"on-viewport":_vm.onViewport},scopedSlots:_vm._u([{key:"default",fn:function({ invalidBrowser }){return [(invalidBrowser || _vm.loaded)?_vm._t("default",null,{"shown":invalidBrowser || _vm.loaded}):_vm._e()]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }